import { ValidationFeedbackEntry } from "@medapro-types/common/common";
import { ValidationFeedbackType } from "@medapro-types/common/common-enum";
import { ValidationRules } from "@medapro-types/util/validations/ruleEvaluator";
import _ from "lodash";

export default <T>(model: T, rules: ValidationRules<T>) => {
  const result: Partial<Record<keyof T, ValidationFeedbackEntry>> = {};
  const validatableFields: (keyof ValidationRules<T>)[] = Object.keys(rules) as (keyof ValidationRules<T>)[];

  for (let fieldIndex = 0; fieldIndex < validatableFields.length; fieldIndex++) {
    const field = validatableFields[fieldIndex];
    const failedRule = _.sortBy(rules[field], (x) => x.severity).find((spec) => spec.rule(model)); //find first rule violating the spec
    if (failedRule) {
      //if found, validation failed
      result[field] = {
        isValid: false,
        feedback: failedRule.msg,
        type: failedRule.severity
      };
    } else {
      result[field] = {
        isValid: true,
        feedback: "",
        type: ValidationFeedbackType.success
      };
    }
  }
  return <Record<keyof T, ValidationFeedbackEntry>>result;
};
